module.exports = __webpack_public_path__ + "static/112263-1ac0f3ddce851a12dbfe4a27a0e07f1d.jpg";